<template>
  <div>
    <empty-table-icon />
    <p class="text-center text-sm">{{ description }}!</p>
  </div>
</template>

<script>
export default {
  props: ["description"],
};
</script>

<style></style>
